import { render, staticRenderFns } from "./ControlActor.vue?vue&type=template&id=37523220&scoped=true&"
import script from "./ControlActor.vue?vue&type=script&lang=js&"
export * from "./ControlActor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37523220",
  null
  
)

export default component.exports